import {Col, Container, Row} from "react-bootstrap";
import SearchComponent from "./SearchComponent";
import Breadcrumb from "./Breadcrumb";
import styled from "styled-components";
import {Link, useLocation} from "react-router-dom";
import {useEffect, useState} from "react";

const StyledHeader = styled.div`
    a.logo {
        margin-top: 15px;
        margin-bottom: 10px;
        display: block;
        width: fit-content;

        h1 {
            color: #000;
            font-size: 24px;
            font-weight: bold;
            line-height: 28px;
            width: fit-content;

            span {
                color: #707070;
                font-weight: 400;
            }
        }
    }

    .search {
        margin-top: 15px;
        margin-bottom: 10px;
    }

    .breadcrumb-container {
        margin-bottom: 20px;
    }

    /* Tablet desktop :768px. */
    @media (min-width: 768px) and (max-width: 991px) {
        a.logo h1 {
            font-size: 18px;
        }
    }


    /* small mobile :320px. */
    @media (max-width: 767px) {
        margin-top: 15px;
        a.logo {

            h1 {
                font-size: 16px;
                line-height: 16px;
            }
        }

        .search {
            display: none;
        }
    }
`;

const Header = ({handleMenuOpen, isOpen}) => {
    const location = useLocation();
    const pathname = location.pathname;
    const [path, setPath] = useState("");

    useEffect(() => {
        const pathMap = {
            "/architecture": "Architecture",
        };
        setPath(pathMap[pathname] || "");
    }, [pathname]);


    return (
        <>
            <StyledHeader>
                <Container>
                    <Row className="align-items-center">
                        <Col className={'d-flex justify-content-between logo-ham-wrap'} lg={6} md={6}>
                            <Link to={'/'} className="logo">
                                <h1><span>Architect</span> Shamsul Wares</h1>
                            </Link>

                            <div onClick={() => handleMenuOpen(!isOpen)} className="hamburger d-md-none">
                                <img width={40} height={40} src="/images/static/hamburger-open.svg" alt="hamburger"/>
                            </div>
                        </Col>
                        <Col className={'d-lg-block d-md-block d-sm-none'} lg={6} md={6}>
                            <div className="search">
                                <SearchComponent/>
                            </div>
                        </Col>
                        <Col>
                            <div className="breadcrumb-container">
                                <Breadcrumb/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </StyledHeader>
            {/* Adds space so content doesn’t hide behind the fixed header */}
            <div className="content-spacing"></div>
        </>
    );
};

export default Header;
